module.exports = __webpack_public_path__ + "static/img/number_bg.6ab7e07e.png";